// メッセージ取得エラー後の再リクエスト最小間隔 (ミリ秒)
const RETRY_FETCH_MIN_INTERVAL = 3000;

// メッセージ取得エラー後の再リクエスト回数上限
const RETRY_FETCH_MAX_COUNT = 5;

/*
 * since_idパラメーターによるロングポーリング
 */
export default class LongPolling {
  constructor (api, url) {
    this.api = api;
    this.url = url;

    // 最終取得時刻 (ミリ秒)
    this.lastFetchedTimeInMillis = 0;

    // 取得エラー後の再リクエスト回数
    this.retryFetchCount = 0;

    // ロングポーリング開始済み
    this.started = false;

    // ロングポーリング停止要求 (stop()が呼ばれた後)
    this.stopRequested = false;

    // 取得済みレコードのid
    this.sinceId = null;

    // データ取得時のハンドラー (デフォルトはnoop関数)
    this.fetchHandler = (data) => {}

    this.errorHandler = (data) => {}
  }

  set onFetch (handler) {
    if (handler === null) {
      this.fetchHandler = (data) => {}
    }
    else {
      this.fetchHandler = handler;
    }
  }

  set onError (handler) {
    if (handler === null) {
      this.errorHandler = (data) => {}
    } else {
      this.errorHandler = handler
    }
  }

  get isStarted () {
    return this.started
  }

  /**
     * データを取得をループします。
   * 2回目以降はsince_idパラメーターにより最新データを待ちます。
     */
  start () {
    if (this.started) return;

    console.log(`Start: ${this.url}`);
    this.started = true;
    this.fetch();
  }

  /**
   *
   */
  fetch () {
    if (this.stopRequested) {
      console.log(`Stopped: ${this.url}`);
      return
    }

    let params = {}
    if (this.sinceId !== null) {
      params['since_id'] = this.sinceId
      console.log(`Waiting for new ${this.url} modified since ${this.sinceId}`);
        }

    this.lastFetchedTimeInMillis = Date.now();

    let get = this.api.request('GET', this.url, {
      params: params
    })
    get.then(res => {
      if (!this.stopRequested) {
        this.onFetchDone(res.data);
      }
    })
    .catch(err => {
      if (!this.stopRequested) {
        this.onFetchFail(err);
      }
    })
  }

  /**
     * 取得したデータをハンドラーへ渡します。
   * 最新メッセージ以降の新着メッセージをリクエストします。
     */
  onFetchDone (data) {

    if (Array.isArray(data) && (0 < data.length)) {
      let last = data[data.length - 1];
      this.sinceId = last.id
      this.fetchHandler(data)
    }
    else if (data.id) {
      this.sinceId = data.id
      this.fetchHandler(data)
    }
    else if (this.sinceId === null) {
      this.sinceId = 0;
      if (this.url.includes('/rooms/') && this.url.includes('/messages')) {
        // apiのurlに'/rooms/'と'/messages'が含まれている場合
        // 初回のmessage取得件数が0件であっても、読込アニメーション制御の為、ハンドラーへデータを渡す
        this.fetchHandler(data)
      }
    }

    this.fetch();
  }

  /**
   * データ取得に失敗した場合に呼ばれます。
   */
    onFetchFail (err) {
    console.log(err);

    let elapsed = Date.now() - this.lastFetchedTimeInMillis;
    if (RETRY_FETCH_MIN_INTERVAL < elapsed) {
      // 正常な状態（サーバー起動中の状態におけるタイムアウト）のためリトライ回数は増やさない。
      this.fetch();
    }
    else {
      if (err.response && err.response.status === 403) {
        this.errorHandler(err)
        this.stop()
      }
      let interval = Math.max(RETRY_FETCH_MIN_INTERVAL - elapsed, 0);
      window.setTimeout(() => this.retryFetch(), interval);
    }
  }

  /**
   * メッセージ取得をリトライします。
   * リトライ回数上限を超えた場合はalertを表示します。
   */
    retryFetch () {
        this.retryFetchCount += 1;
        if (RETRY_FETCH_MAX_COUNT < this.retryFetchCount) {
            // TODO エラーメッセージ
      window.alert('システムに問題が発生しています。');
        }
        else {
            this.fetch();
        }
    }

  /**
     * ロングポーリングを停止します。
   * 実行中のリクエストは最後まで実行されます。
     */
    stop () {
    if (this.started && !this.stopRequested) {
      console.log(`Stop requested: ${this.url}`);
      this.stopRequested = true;
    }
    }

}



// WEBPACK FOOTER //
// ./app-common-vue/src/lib/LongPolling.js